// extracted by mini-css-extract-plugin
export var productImage = "_zi-0";